



































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import HasAnswered from '@/components/Programmation/HasAnswered.vue'
import { filterUserModules } from '@/utils/filterUserModules'
import { UserModule } from '@/store/modules/user'
import { nickname } from '@/utils/nickname'
import { getOperationID } from '@/api/operations'
import { formatRelativeDate } from '@/filters/formatRelativeDate'
import ModuleProgrammation from '@/components/ModuleProgrammation.vue'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'

type Filter = 'all' | 'user' | 'operation' | 'group'
type Status = 'closed' | 'opened' | 'created'

@Component({
    filters: {
        formatRelativeDate,
    },
    components: {
        HasAnswered,
        SmoothReflow,
        ModuleProgrammation,
    },
})
export default class ModulesList extends Vue {
    allModules: any[] = []
    loaded: boolean = false
    userID: number = null
    opeID: number = null
    @Prop({ type: String, default: 'all' }) filter: Filter
    selectedModule: any = null
    async created() {
        await this.init()
    }

    async init() {
        await UserModule.Init()
        this.userID = UserModule.userInfos.id
        this.opeID = await getOperationID()

        const apiService = new ApiService()

        const resp = await apiService.getModules()
        const modules = resp.data

        this.allModules = modules
        this.loaded = true
    }

    hideModal() {
        this.init()
        this.selectedModule = null
        const $moduleModal: any = $(this.$refs.moduleModal)
        $moduleModal.modal('hide')
    }

    get modules() {
        return filterUserModules(this.allModules, this.userID, this.opeID)
    }

    get modulesWithMoreData() {
        return this.modules.map((module: any) => {
            // users
            const users = module.hasAnswered.map(user => {
                const name = nickname(user.firstname, user.lastname)

                return {
                    name,
                }
            })

            // completed
            const user = find(module.hasAnswered, {
                id: this.userID,
            })
            const completed = user ? true : false

            // status
            const now = new Date()
            const closeAt = new Date(module.closeAt)
            const openAt = new Date(module.openAt)

            let status: Status
            if (now > closeAt) {
                status = 'closed'
            } else if (now > openAt) {
                status = 'opened'
            } else {
                status = 'created'
            }

            return {
                ...module,
                users,
                status,
                completed,
            }
        })
    }

    get sortedModules() {
        const sortedModules = orderBy(this.modulesWithMoreData, [
            module => {
                switch (module.status) {
                    case 'opened':
                        return 0
                    case 'closed':
                        return 1
                    case 'created':
                        return 2
                }
            },
            module => {
                if (module.completed) {
                    return 0
                } else {
                    return 1
                }
            },
            module => {
                switch (module.status) {
                    case 'closed':
                        return -new Date(module.closeAt)
                    case 'opened':
                        return new Date(module.closeAt)
                    case 'created':
                        return new Date(module.openAt)
                }
            },
        ])
        return sortedModules
    }

    get filteredModules() {
        return this.sortedModules.filter(module => {
            if (this.filter === 'all') {
                return true
            }

            return module.type === this.filter
        })
    }

    showModule(module) {
        this.selectedModule = module
        const $moduleModal: any = $(this.$refs.moduleModal)
        $moduleModal.modal('show')
    }

    downloadModule(module) {
        this.$emit('downloadModule', module)
    }
}
